import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';

import _ from 'lodash';
import { useNavigate } from 'react-router-dom';

export default function Home () {
  const isSearchEnabled = useSelector((state: any) =>
    _.get(state, "users.me.userRoles[0].search.access")
  );
  const isHubEnabled = useSelector((state: any) => _.get(state, "users.me.userRoles[0].hub.access"));

  const navigate = useNavigate();

  useEffect(() => {
    if (isSearchEnabled ) {
      navigate("/search");
    } else if(isHubEnabled ){
      navigate("/hub");
    }else{
      navigate("/collections")
    }
  }, [isSearchEnabled,isHubEnabled]);
    
  return <></>;
}